import { NgModule } from '@angular/core';

import {
  AvatarComponent,
  CloseIconComponent,
  ChipComponent,
  DrawerComponent,
  ModalComponent,
  TabComponent,
  TabsComponent,
} from '../public-api';

@NgModule({
  imports: [
    AvatarComponent,
    CloseIconComponent,
    DrawerComponent,
    ModalComponent,
    ChipComponent,
    TabsComponent,
    TabComponent
  ],
  exports: [
    AvatarComponent,
    CloseIconComponent,
    DrawerComponent,
    ModalComponent,
    ChipComponent,
    TabsComponent,
    TabComponent
  ],
})
export class GeneAiUiModule { }
